if (!customElements.get("video-controls")) {
    customElements.define(
      "video-controls",
      class VideoControls extends HTMLElement {
        constructor() {
          super();
        }


        connectedCallback() {
          this.video = this.querySelector("video");
          this.hasVideoClickToggle = this.dataset.videoClick === "false" ? false : true;
          this.productsContainer = this.querySelector(
            ".shoppable-video__products",
          );
          this.controlButton = this.querySelector(
            ".shoppable-video__control-button",
          );

          this.togglePlayPause = this.togglePlayPause.bind(this);
          this.toggleVideoIcon = this.toggleVideoIcon.bind(this);

          this.addEventListeners();
          if(this.controlButton && this.video) this.toggleVideoIcon();
        }

        addEventListeners() {
          if(this.controlButton) this.controlButton.addEventListener("click", this.togglePlayPause);
          if(this.video && this.hasVideoClickToggle) this.video.addEventListener("click", this.togglePlayPause);
          if(this.controlButton && this.video){
            this.video.addEventListener("play", this.toggleVideoIcon);
            this.video.addEventListener("pause", this.toggleVideoIcon);
          }
        }

        removeEventListeners() {
          if(this.controlButton) this.controlButton.removeEventListener("click", this.togglePlayPause);
          if(this.video && this.hasVideoClickToggle) this.video.removeEventListener("click", this.togglePlayPause);
          if(this.controlButton && this.video){
            this.video.removeEventListener("play", this.toggleVideoIcon);
            this.video.removeEventListener("pause", this.toggleVideoIcon);
          }
        }

        toggleVideoIcon() {
          const isPlaying = !this.video.paused;
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--play",
            isPlaying,
          );
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--pause",
            !isPlaying,
          );
        }

        togglePlayPause(e) {
          e.preventDefault();
          const videoElement = this.video;

          if (!videoElement) return;

          if (videoElement.paused || videoElement.ended) {
            videoElement.play();
          } else {
            videoElement.pause();
          }
        }

        disconnectedCallback(){
          this.removeEventListeners();
        }

      },
    );
  }

/* ---------------------------------------------------------------
 * RB hero volume control
 * Gold pill, speaker toggle, volume slider that collapses after
 * 3 seconds idle. Scoped to .section-background-video so it never
 * collides with the slider already added in video-reels.js.
 *
 * Sizing is set inline from JS, and sets BOTH flex-basis and width.
 * The pill is an absolutely positioned (shrink-to-fit) flex
 * container, and a flex child with overflow:hidden resolves to zero
 * from flex-basis alone - the explicit width is what holds it open.
 *
 * Video stays muted on load because browsers block autoplay audio.
 * --------------------------------------------------------------- */
(function () {
  var GOLD = '#b7a56e';
  var IDLE_MS = 3000;
  var W_DESK = 88;
  var W_MOB = 64;

  var CSS = [
    '.rbv{position:absolute;right:20px;bottom:20px;z-index:40;display:flex;align-items:center;',
      'background:rgba(21,21,21,.72);border:1px solid rgba(183,165,110,.45);border-radius:999px;',
      'padding:7px 10px;backdrop-filter:blur(5px);transition:border-color .22s ease,box-shadow .22s ease}',
    '.rbv:hover,.rbv.is-open{border-color:' + GOLD + ';box-shadow:0 0 16px rgba(183,165,110,.28)}',
    '.rbv-slider{overflow:hidden;',
      'transition:width .26s ease,flex-basis .26s ease,opacity .2s ease,margin-right .26s ease}',
    '.rbv-slider input[type=range]{display:block;height:3px;margin:0;cursor:pointer;',
      'accent-color:' + GOLD + ';background:rgba(183,165,110,.25);border-radius:2px;appearance:none;-webkit-appearance:none}',
    '.rbv-slider input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:11px;height:11px;border-radius:50%;background:' + GOLD + ';border:0}',
    '.rbv-slider input[type=range]::-moz-range-thumb{width:11px;height:11px;border-radius:50%;background:' + GOLD + ';border:0}',
    '.rbv-btn{flex:0 0 auto;display:flex;align-items:center;justify-content:center;width:20px;height:20px;padding:0;',
      'background:none;border:0;cursor:pointer;color:' + GOLD + '}',
    '.rbv-btn svg{width:18px;height:18px;display:block;fill:none;stroke:currentColor;stroke-width:1.6;',
      'stroke-linecap:round;stroke-linejoin:round}',
    '.rbv .rbv-on{display:none}',
    '.rbv.is-sound .rbv-on{display:block}',
    '.rbv.is-sound .rbv-off{display:none}',
    '@media (max-width:749px){.rbv{right:12px;bottom:12px;padding:6px 9px}}'
  ].join('');

  var SPK = '<path d="M4 9v6h3.5L12 19V5L7.5 9H4z"/>';
  var ICON_OFF = '<svg class="rbv-off" viewBox="0 0 24 24" aria-hidden="true">' + SPK + '<line x1="16" y1="9" x2="21" y2="15"/><line x1="21" y1="9" x2="16" y2="15"/></svg>';
  var ICON_ON  = '<svg class="rbv-on" viewBox="0 0 24 24" aria-hidden="true">' + SPK + '<path d="M16 8.5a4.5 4.5 0 0 1 0 7"/><path d="M18.5 6a8 8 0 0 1 0 12"/></svg>';

  function trackWidth() {
    return window.matchMedia('(max-width:749px)').matches ? W_MOB : W_DESK;
  }

  function injectCSS() {
    var old = document.getElementById('rbv-css');
    if (old && old.dataset.v === '4') return;
    if (old) old.remove();
    var st = document.createElement('style');
    st.id = 'rbv-css';
    st.dataset.v = '4';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function build(stage, video) {
    if (stage.querySelector('.rbv')) return;
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';

    var wrap = document.createElement('div');
    wrap.className = 'rbv';

    var sl = document.createElement('div');
    sl.className = 'rbv-slider';

    var input = document.createElement('input');
    input.type = 'range';
    input.min = '0'; input.max = '1'; input.step = '0.05'; input.value = '0.7';
    input.setAttribute('aria-label', 'Volume');
    input.style.width = trackWidth() + 'px';
    sl.appendChild(input);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rbv-btn';
    btn.setAttribute('aria-label', 'Unmute');
    btn.innerHTML = ICON_OFF + ICON_ON;

    wrap.appendChild(sl);
    wrap.appendChild(btn);
    stage.appendChild(wrap);

    video.volume = parseFloat(input.value);

    var hovering = false;
    var idleTimer = null;

    function setTrack(px) {
      sl.style.flex = '0 0 ' + px + 'px';
      sl.style.width = px + 'px';
      sl.style.minWidth = px + 'px';
      sl.style.opacity = px ? '1' : '0';
      sl.style.marginRight = px ? '10px' : '0px';
    }

    function showTrack() {
      var w = trackWidth();
      input.style.width = w + 'px';
      setTrack(w);
      wrap.classList.add('is-open');
    }

    function hideTrack() {
      setTrack(0);
      wrap.classList.remove('is-open');
    }

    hideTrack();

    function collapse() {
      if (hovering) return;
      hideTrack();
    }

    function openPanel() {
      showTrack();
      clearTimeout(idleTimer);
      idleTimer = setTimeout(collapse, IDLE_MS);
    }

    wrap.addEventListener('mouseenter', function () {
      hovering = true;
      clearTimeout(idleTimer);
      showTrack();
    });

    wrap.addEventListener('mouseleave', function () {
      hovering = false;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(collapse, IDLE_MS);
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var turningOn = video.muted;
      video.muted = !turningOn;
      if (turningOn) {
        video.volume = parseFloat(input.value);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      wrap.classList.toggle('is-sound', turningOn);
      btn.setAttribute('aria-label', turningOn ? 'Mute' : 'Unmute');
      openPanel();
    });

    input.addEventListener('input', function () {
      video.volume = parseFloat(input.value);
      if (video.volume === 0) {
        video.muted = true;
        wrap.classList.remove('is-sound');
        btn.setAttribute('aria-label', 'Unmute');
      } else if (video.muted) {
        video.muted = false;
        wrap.classList.add('is-sound');
        btn.setAttribute('aria-label', 'Mute');
      }
      openPanel();
    });

    ['click', 'pointerdown', 'touchstart', 'mousedown'].forEach(function (evt) {
      wrap.addEventListener(evt, function (e) { e.stopPropagation(); });
    });
  }

  function boot() {
    injectCSS();
    document.querySelectorAll('.section-background-video').forEach(function (stage) {
      var video = stage.querySelector('video');
      if (video) build(stage, video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 800);
  setTimeout(boot, 2000);
})();
